import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import service from "./service.module";
// import buymessage from "./buymessage.module";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    service,
    // buymessage
    // profile
  },
});

export default store;
